import React from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Row, Col, Button } from 'react-bootstrap';
import { FormikInput, ButtonTooltip, Icon } from '../../../components';

export const StructuredPreferenceOrderLayout = ({
  valuePath,
  questionChoicesAttributes = [],
  addChoice,
  deleteChoice
}) => {
  const { errors, touched } = useFormikContext();
  const visibleChoices = questionChoicesAttributes.filter(c => !c._destroy);

  return (
    <div className="mt-3">
      <Row>
        <Col md={10}>
          <Field name={`${valuePath}[label]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Pregunta"
                maxLength={100}
                tooltipText="Máximo 100 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Field name={`${valuePath}[description]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Descripción opcional"
                maxLength={300}
                placeholder="Arrastre y suelte para cambiar el orden"
                tooltipText="Máximo 300 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      <div className="mt-3">
        {questionChoicesAttributes.map((choice, choiceIndex) => {
          if (choice._destroy) return null;
          const visibleIndex = questionChoicesAttributes.slice(0, choiceIndex).filter(c => !c._destroy).length;
          return (
            <Row
              key={choice.id ? `choice-${choice.id}` : `choice-pos-${choice.position}`}
              className="align-items-center mb-2"
            >
              <Col xs="auto">
                <span className="text-muted eval-scale-row-label">
                  {`Respuesta ${visibleIndex + 1}`}
                </span>
              </Col>
              <Col>
                <Field name={`${valuePath}[questionChoicesAttributes][${choiceIndex}][label]`}>
                  {({ field }) => (
                    <FormikInput
                      {...field}
                      placeholder={`Respuesta ${visibleIndex + 1}`}
                      maxLength={100}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col xs="auto">
                <ButtonTooltip
                  variant="circle-danger"
                  className="btn-circle"
                  size="sm"
                  text="Eliminar"
                  onClick={() => deleteChoice(choiceIndex)}
                  disabled={visibleChoices.length <= 2}
                >
                  <Icon icon="trash" />
                </ButtonTooltip>
              </Col>
            </Row>
          );
        })}
      </div>

      <Row className="mt-2">
        <Col className="d-flex justify-content-end">
          <Button variant="primary" size="sm" onClick={addChoice}>
            Agregar Respuesta
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default StructuredPreferenceOrderLayout;
